import React from 'react';
import { useTheme } from 'react-native-paper';
import { t } from '@lingui/macro';
import { createStackNavigator } from '@react-navigation/stack';

import { CheckAccess } from '@src/helpers/hasAccessMember';
import useAllStatus from '@src/hooks/useAllStatus';
import { i18n } from '@src/i18n';
import OfflineScreen from '@src/screens/Offline';
import PrimeBookAudioReaderScreen from '@src/screens/PrimeBookAudioReader';
import PrimeBookMenuScreen from '@src/screens/PrimeBookMenu';
import PrimeBookTextReaderScreen from '@src/screens/PrimeBookTextReader';
import PrimeLibraryScreen from '@src/screens/PrimeLibrary';

import { OfflineRootStackParamList } from './types';

const Stack = createStackNavigator<OfflineRootStackParamList>();

const Component: React.FC = () => {
  const theme = useTheme();
  // const hasPrime = useHasPrime();
  const hasPrime = CheckAccess(useAllStatus()) > 0;

  return (
    <Stack.Navigator
      headerMode="screen"
      screenOptions={{
        headerBackTitle: i18n._(t`Back`),
        headerTruncatedBackTitle: i18n._(t`Back`),
        headerTitleStyle: {
          fontFamily: theme.fonts.medium.fontFamily,
          fontWeight: theme.fonts.medium.fontWeight,
        },
        headerBackTitleStyle: {
          fontFamily: theme.fonts.regular.fontFamily,
          fontWeight: theme.fonts.regular.fontWeight,
        },
        headerStyle: {
          elevation: 0,
          borderBottomWidth: 0,
        },
      }}
    >
      <Stack.Screen
        name="Offline"
        component={OfflineScreen}
        options={{
          title: i18n._(t`Can not connect to server`),
          headerShown: false,
        }}
      />
      {hasPrime && (
        <>
          <Stack.Screen
            name="PrimeLibrary"
            component={PrimeLibraryScreen}
            options={{ title: i18n._(t`My Library`) }}
          />
          <Stack.Screen
            name="PrimeBookAudioReader"
            component={PrimeBookAudioReaderScreen}
            options={{
              headerTitle: '',
              title: i18n._(t`Prime Book Reader`),
            }}
          />
          <Stack.Screen
            name="PrimeBookTextReader"
            component={PrimeBookTextReaderScreen}
            options={{
              headerTitle: '',
              title: i18n._(t`Prime Book Reader`),
            }}
          />
          <Stack.Screen
            name="PrimeBookMenu"
            component={PrimeBookMenuScreen}
            options={{
              title: i18n._(t`Prime Book Menu`),
            }}
          />
        </>
      )}
    </Stack.Navigator>
  );
};

Component.displayName = 'AuthenticatedRootStack';

export default Component;
